import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Check from '@mui/icons-material/Check';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

export default function AdvancedFeaturesPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        mt: 6, // top spacing
        mb: 6, // bottom spacing
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
          gap: 3,
          maxWidth: 900,
          width: '100%',
          px: 2,
        }}
      >
        {/* Logo and Title */}
        <Box
          sx={{
            gridColumn: '1 / -1', // span entire grid width
            textAlign: 'center',
            my: 2,
          }}
        >
          <Typography variant="h1" sx={{ my: 1 }}>
            <img
              src="../xfactualLogo.png"
              alt="XFactual Logo"
              style={{ width: "200px", height: "auto" }}
            />
          </Typography>
        </Box>

        {/* Monthly Plan Card */}
        <Card variant="outlined">
          <Box sx={{ p: 2 }}>
            <Chip label="BASIC" size="small" variant="outlined" />
            <Typography variant="h5" sx={{ my: 1 }}>
              Monthly Plan
            </Typography>
            <Divider />
            <List>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check />
                </ListItemIcon>
                <ListItemText primary="YouTube Integration" />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check />
                </ListItemIcon>
                <ListItemText primary="Bing Integration" />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check />
                </ListItemIcon>
                <ListItemText primary="Extended Document Analysis" />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check />
                </ListItemIcon>
                <ListItemText primary="API Integration" />
              </ListItem>
            </List>
            <Divider />
            <CardActions sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ flexGrow: 1 }}>
                $5{' '}
                <Typography variant="caption" sx={{ fontSize: '0.8rem' }}>
                  / month
                </Typography>
              </Typography>
              <Button variant="outlined" endIcon={<KeyboardArrowRight />}>
                Start now
              </Button>
            </CardActions>
          </Box>
        </Card>

        {/* Annual Plan Card */}
        <Card sx={{ bgcolor: 'grey.900' }}>
          <Box sx={{ p: 2 }}>
            <Chip label="MOST POPULAR" size="small" variant="outlined" />
            <Typography variant="h5" sx={{ my: 1, color: 'common.white' }}>
              Annual Plan
            </Typography>
            <Divider sx={{ borderColor: 'grey.700' }} />
            <List sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check sx={{ color: 'common.white' }} />
                </ListItemIcon>
                <ListItemText
                  primary="YouTube Integration"
                  primaryTypographyProps={{ color: 'common.white' }}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check sx={{ color: 'common.white' }} />
                </ListItemIcon>
                <ListItemText
                  primary="Bing Integration"
                  primaryTypographyProps={{ color: 'common.white' }}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check sx={{ color: 'common.white' }} />
                </ListItemIcon>
                <ListItemText
                  primary="Extended Document Analysis"
                  primaryTypographyProps={{ color: 'common.white' }}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check sx={{ color: 'common.white' }} />
                </ListItemIcon>
                <ListItemText
                  primary="API Integration"
                  primaryTypographyProps={{ color: 'common.white' }}
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon>
                  <Check sx={{ color: 'common.white' }} />
                </ListItemIcon>
                <ListItemText
                  primary="Image & Facial Processing"
                  primaryTypographyProps={{ color: 'common.white' }}
                />
              </ListItem>
            </List>
            <Divider sx={{ borderColor: 'grey.700' }} />
            <CardActions sx={{ mt: 1 }}>
              <Typography variant="h6" sx={{ flexGrow: 1, color: 'common.white' }}>
                $60{' '}
                <Typography variant="caption" sx={{ fontSize: '0.8rem', color: 'grey.300' }}>
                  / year
                </Typography>
              </Typography>
              <Button variant="contained" endIcon={<KeyboardArrowRight />}>
                Start now
              </Button>
            </CardActions>
          </Box>
        </Card>

        {/* Additional Note at the Bottom */}
        <Box
          sx={{
            gridColumn: '1 / -1', // span entire grid width
            textAlign: 'center',
            mt: 4,
          }}
        >
          <Typography variant="body2">
            Beta testing is scheduled to conclude on <strong>August 1, 2025</strong>. 
            After this date, these subscription plans will be fully available.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
